import { render, staticRenderFns } from "./mapping-table-management.vue?vue&type=template&id=3edfafa0"
import script from "./mapping-table-management.vue?vue&type=script&lang=ts"
export * from "./mapping-table-management.vue?vue&type=script&lang=ts"
import style0 from "./mapping-table-management.vue?vue&type=style&index=0&id=3edfafa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports